// $('.toproom-share').hover(function () {
//         $('.sharepanel').show();
//     },
//     function () {
//         $('.sharepanel').hide();
//     }
// );

$('body').on('mouseenter', '.toproom-share', function () {
    var x = $(this).offset();
    x.left -= 20;
    $('.sharepanel').css('left', x.left + 'px');
    // $('.sharepanel').css('top', x.top + 'px');

    $('.sharepanel').show();
});
$('body').on('mouseleave', '.toproom-share', function () {
    setTimeout('hidedropdown()', 200);
});

function hidedropdown() {
    if ($('.sharepanel').data('show') != 'true') {
        $('.sharepanel').hide();
    }
}

$('.sharepanel').hover(function () {
    $('.sharepanel').data('show', 'true');
    $('.sharepanel').show();
}, function () {
    $('.sharepanel').hide();
    $('.sharepanel').data('show', 'false');
});